var exports = {
  "t": "flexCenter__gJJ5MF",
  "w": "repoIcon__27Tcuw",
};

module.exports = exports;
